import React, { useState, useEffect } from "react";

interface SiteData {
  hero: {
    badge: string;
    title1: string;
    title2: string;
    description: string;
    stat1Number: string;
    stat1Label: string;
    stat2Number: string;
    stat2Label: string;
    stat3Number: string;
    stat3Label: string;
    stat4Number: string;
    stat4Label: string;
  };
  services: {
    web: { title: string; description: string; features: string[] };
    ses: { title: string; description: string; features: string[] };
    canli: { title: string; description: string; features: string[] };
  };
  portfolio: Array<{
    id: number;
    title: string;
    domain: string;
    description: string;
    tags: string[];
    image?: string;
  }>;
  videos: Array<{
    id: number;
    title: string;
    description: string;
    url: string;
  }>;
  contact: {
    phone: string;
    email: string;
    location: string;
    workingHours: string;
  };
  about: {
    title: string;
    description1: string;
    description2: string;
    description3: string;
    stat1Number: string;
    stat1Label: string;
    stat2Number: string;
    stat2Label: string;
    stat3Number: string;
    stat3Label: string;
    stat4Number: string;
    stat4Label: string;
    skills: Array<{ icon: string; title: string; desc: string }>;
  };
}

const Admin: React.FC = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [password, setPassword] = useState("");
  const [data, setData] = useState<SiteData>({
    hero: {
      badge: "Web Tasarım & Sesli Yazıya Çeviri Uzmanı",
      title1: "Dijital dünyada",
      title2: "fark yaratıyoruz",
      description: "Profesyonel web tasarım hizmetleri ve dünya şampiyonu sesli yazıya çeviri uzmanlığı ile işinizi bir üst seviyeye taşıyoruz.",
      stat1Number: "5+", stat1Label: "Tamamlanan Web Sitesi",
      stat2Number: "7", stat2Label: "Dünya Şampiyonluğu",
      stat3Number: "20+", stat3Label: "Sesi Yazıya Çevirme",
      stat4Number: "20+", stat4Label: "Canlı Altyazı",
    },
    services: {
      web: { title: "Web Tasarım", description: "Modern, responsive ve kullanıcı dostu web siteleri tasarlıyorum.", features: ["Responsive tasarım", "Modern arayüz", "SEO uyumlu yapı", "Hızlı yüklenme"] },
      ses: { title: "Sesli Yazıya Çeviri", description: "Dünya şampiyonu hassasiyetinde ses kayıtlarını yazıya çeviriyorum.", features: ["Yüksek doğruluk oranı", "Hızlı teslimat", "Çoklu dil desteği", "Gizlilik garantisi"] },
      canli: { title: "Canlı Altyazı", description: "Etkinlikler, konferanslar ve canlı yayınlar için gerçek zamanlı altyazı hizmeti sunuyorum.", features: ["Gerçek zamanlı çeviri", "Etkinlik deneyimi", "Profesyonel ekipman", "Esnek programlama"] },
    },
    portfolio: [
      { id: 1, title: "Vize Bilgi Merkezi", domain: "vizebilgimerkezi.com", description: "React + TypeScript ile gelistirilen, 7 ulke icin detayli vize rehberleri sunan premium uyelik platformu.", tags: ["React", "TypeScript", "Premium Uyelik", "Admin Panel"] },
    ],
    videos: [
      { id: 1, title: "Canli Altyazi Calismasi", description: "Kongre'de yabanci konuklarin konusmasi canli altyazi olarak ekrana aktarildi.", url: "" },
    ],
    contact: { phone: "0850 XXX XX XX", email: "info@hkdesign.com", location: "Türkiye", workingHours: "Pazartesi - Cuma: 09:00 - 18:00" },
    about: {
      title: "Merhaba, ben Hakan",
      description1: "Web tasarım ve dijital çözümler alanında çalışmalarımı sürdürüyorum.",
      description2: "Aynı zamanda sesli yazıya çevirme konusunda dünya klavye şampiyonuyum.",
      description3: "Her projede müşteri memnuniyetini ön planda tutarak çalışıyorum.",
      stat1Number: "5+", stat1Label: "Tamamlanan Web Sitesi",
      stat2Number: "7", stat2Label: "Dünya Şampiyonluğu",
      stat3Number: "20+", stat3Label: "Sesi Yazıya Çevirme",
      stat4Number: "20+", stat4Label: "Canlı Altyazı",
      skills: [
        { icon: "🎨", title: "Web Tasarim", desc: "Modern, responsive web siteleri" },
        { icon: "🎙️", title: "Sesi Yayiya Ceviri", desc: "Dunya sampiyonu hassasiyet" },
        { icon: "📺", title: "Canli Altyazi", desc: "Gercek zamanli altyazi hizmeti" },
        { icon: "⚛️", title: "React & TypeScript", desc: "Modern web uygulamalari gelistirme" },
      ],
    },
  });
  const [activeTab, setActiveTab] = useState("hero");
  const [saveMsg, setSaveMsg] = useState("");

  useEffect(() => {
    const saved = localStorage.getItem("hkdesign_data");
    if (saved) {
      const parsed = JSON.parse(saved);
      if (!parsed.videos) parsed.videos = [];
      if (!parsed.about) {
        parsed.about = {
          title: "Merhaba, ben Hakan",
          description1: "Web tasarım ve dijital çözümler alanında çalışmalarımı sürdürüyorum.",
          description2: "Aynı zamanda sesli yazıya çevirme konusunda dünya klavye şampiyonuyum.",
          description3: "Her projede müşteri memnuniyetini ön planda tutarak çalışıyorum.",
          stat1Number: "5+", stat1Label: "Tamamlanan Web Sitesi",
          stat2Number: "7", stat2Label: "Dünya Şampiyonluğu",
          stat3Number: "20+", stat3Label: "Sesi Yazıya Çevirme",
          stat4Number: "20+", stat4Label: "Canlı Altyazı",
          skills: [
            { icon: "⚛️", title: "React & TypeScript", desc: "Modern web uygulamaları geliştirme" },
            { icon: "🎨", title: "UI/UX Tasarım", desc: "Kullanıcı odaklı arayüz tasarımı" },
            { icon: "📱", title: "Responsive Tasarım", desc: "Tüm cihazlarda mükemmel görünüm" },
          ],
        };
      }
      setData(parsed);
    }
  }, []);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === "hkdesign2026") {
      setIsAuth(true);
    } else {
      alert("Yanlis sifre!");
    }
  };

  const handleSave = () => {
    localStorage.setItem("hkdesign_data", JSON.stringify(data));
    setSaveMsg("Kaydedildi!");
    setTimeout(() => setSaveMsg(""), 2000);
  };

  const updateHero = (field: string, value: string) => {
    setData({ ...data, hero: { ...data.hero, [field]: value } });
  };

  const updateService = (service: string, field: string, value: string) => {
    setData({
      ...data,
      services: {
        ...data.services,
        [service]: { ...(data.services as any)[service], [field]: value },
      },
    });
  };

  const updateServiceFeature = (service: string, index: number, value: string) => {
    const features = [...(data.services as any)[service].features];
    features[index] = value;
    setData({
      ...data,
      services: {
        ...data.services,
        [service]: { ...(data.services as any)[service], features },
      },
    });
  };

  const updatePortfolio = (id: number, field: string, value: any) => {
    setData({
      ...data,
      portfolio: data.portfolio.map((p) => (p.id === id ? { ...p, [field]: value } : p)),
    });
  };

  const addPortfolioItem = () => {
    const newId = Math.max(0, ...data.portfolio.map((p) => p.id)) + 1;
    setData({
      ...data,
      portfolio: [...data.portfolio, { id: newId, title: "Yeni Proje", domain: "ornek.com", description: "Aciklama", tags: ["Web Tasarim"] }],
    });
  };

  const removePortfolioItem = (id: number) => {
    setData({ ...data, portfolio: data.portfolio.filter((p) => p.id !== id) });
  };

  const handleImageUpload = (id: number, file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target?.result as string;
      updatePortfolio(id, "image", base64);
    };
    reader.readAsDataURL(file);
  };

  const removeImage = (id: number) => {
    updatePortfolio(id, "image", "");
  };

  const updateContact = (field: string, value: string) => {
    setData({ ...data, contact: { ...data.contact, [field]: value } });
  };

  const updateAbout = (field: string, value: string) => {
    setData({ ...data, about: { ...data.about, [field]: value } });
  };

  const updateSkill = (index: number, field: string, value: string) => {
    const skills = [...data.about.skills];
    (skills[index] as any)[field] = value;
    setData({ ...data, about: { ...data.about, skills } });
  };

  const addSkill = () => {
    const skills = [...data.about.skills, { icon: "✨", title: "Yeni Alan", desc: "Aciklama" }];
    setData({ ...data, about: { ...data.about, skills } });
  };

  const removeSkill = (index: number) => {
    const skills = data.about.skills.filter((_, i) => i !== index);
    setData({ ...data, about: { ...data.about, skills } });
  };

  const updateVideo = (id: number, field: string, value: string) => {
    setData({
      ...data,
      videos: data.videos.map((v) => (v.id === id ? { ...v, [field]: value } : v)),
    });
  };

  const addVideo = () => {
    const newId = Math.max(0, ...data.videos.map((v) => v.id)) + 1;
    setData({
      ...data,
      videos: [...data.videos, { id: newId, title: "Yeni Video", description: "", url: "" }],
    });
  };

  const removeVideo = (id: number) => {
    setData({ ...data, videos: data.videos.filter((v) => v.id !== id) });
  };

  const inputStyle: React.CSSProperties = { width: "100%", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "1rem", marginBottom: "8px" };
  const labelStyle: React.CSSProperties = { display: "block", fontWeight: 600, marginBottom: "4px", fontSize: "0.9rem" };

  if (!isAuth) {
    return (
      <div style={{ padding: "160px 24px", textAlign: "center" }}>
        <h1 style={{ marginBottom: "24px" }}>Admin Giris</h1>
        <form onSubmit={handleLogin} style={{ maxWidth: "300px", margin: "0 auto" }}>
          <input type="password" placeholder="Sifre" value={password} onChange={(e) => setPassword(e.target.value)} style={{ ...inputStyle, marginBottom: "16px" }} />
          <button type="submit" className="btn-primary" style={{ width: "100%" }}>Giris Yap</button>
        </form>
      </div>
    );
  }

  const tabs = ["hero", "services", "portfolio", "videos", "about", "contact"];
  const tabLabels: Record<string, string> = { hero: "Hero / Ana Sayfa", services: "Hizmetler", portfolio: "Portfoy", videos: "Videolar", about: "Hakkimda", contact: "Iletisim" };

  return (
    <div style={{ padding: "120px 24px 60px", maxWidth: "900px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px" }}>
        <h1>Admin Panel</h1>
        <button className="btn-primary" onClick={handleSave}>Kaydet</button>
      </div>

      {saveMsg && <div style={{ background: "#10b981", color: "white", padding: "12px", borderRadius: "8px", marginBottom: "16px", textAlign: "center" }}>{saveMsg}</div>}

      <div style={{ display: "flex", gap: "8px", marginBottom: "32px", flexWrap: "wrap" }}>
        {tabs.map((tab) => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{ padding: "10px 20px", border: "1px solid #e2e8f0", borderRadius: "8px", background: activeTab === tab ? "#2563eb" : "white", color: activeTab === tab ? "white" : "#1e293b", cursor: "pointer", fontWeight: 600 }}>
            {tabLabels[tab]}
          </button>
        ))}
      </div>

      {/* HERO */}
      {activeTab === "hero" && (
        <div>
          <h2 style={{ marginBottom: "16px" }}>Hero Bolumu</h2>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Badge Yazisi</label>
            <input value={data.hero.badge} onChange={(e) => updateHero("badge", e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Baslik Satiri 1</label>
            <input value={data.hero.title1} onChange={(e) => updateHero("title1", e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Baslik Satiri 2 (vurgulu)</label>
            <input value={data.hero.title2} onChange={(e) => updateHero("title2", e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Aciklama</label>
            <textarea value={data.hero.description} onChange={(e) => updateHero("description", e.target.value)} rows={4} style={inputStyle} />
          </div>
          <h3 style={{ marginTop: "20px", marginBottom: "12px" }}>Istatistikler</h3>
          {[
            ["stat1Number", "Sayi 1", "stat1Label", "Etiket 1"],
            ["stat2Number", "Sayi 2", "stat2Label", "Etiket 2"],
            ["stat3Number", "Sayi 3", "stat3Label", "Etiket 3"],
            ["stat4Number", "Sayi 4", "stat4Label", "Etiket 4"],
          ].map(([numField, numLabel, lblField, lblLabel]) => (
            <div key={numField} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
              <div>
                <label style={labelStyle}>{numLabel}</label>
                <input value={(data.hero as any)[numField]} onChange={(e) => updateHero(numField, e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>{lblLabel}</label>
                <input value={(data.hero as any)[lblField]} onChange={(e) => updateHero(lblField, e.target.value)} style={inputStyle} />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* SERVICES */}
      {activeTab === "services" && (
        <div>
          <h2 style={{ marginBottom: "24px" }}>Hizmetler</h2>
          {(["web", "ses", "canli"] as const).map((s) => (
            <div key={s} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px", marginBottom: "20px" }}>
              <h3 style={{ marginBottom: "16px" }}>{s === "web" ? "Web Tasarim" : s === "ses" ? "Sesli Yayiya Ceviri" : "Canli Altyazi"}</h3>
              <label style={labelStyle}>Baslik</label>
              <input value={data.services[s].title} onChange={(e) => updateService(s, "title", e.target.value)} style={inputStyle} />
              <label style={labelStyle}>Aciklama</label>
              <textarea value={data.services[s].description} onChange={(e) => updateService(s, "description", e.target.value)} rows={3} style={inputStyle} />
              <label style={labelStyle}>Ozellikler</label>
              {data.services[s].features.map((f, i) => (
                <input key={i} value={f} onChange={(e) => updateServiceFeature(s, i, e.target.value)} style={inputStyle} />
              ))}
            </div>
          ))}
        </div>
      )}

      {/* PORTFOLIO */}
      {activeTab === "portfolio" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
            <h2>Portfoy Projeleri</h2>
            <button className="btn-primary" onClick={addPortfolioItem}>+ Yeni Proje</button>
          </div>
          {data.portfolio.map((item) => (
            <div key={item.id} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px", marginBottom: "16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <h3>Proje #{item.id}</h3>
                <button onClick={() => removePortfolioItem(item.id)} style={{ background: "#ef4444", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer" }}>Sil</button>
              </div>

              {/* Gorsel Yukleme */}
              <div style={{ marginBottom: "16px" }}>
                <label style={labelStyle}>Proje Gorseli (Screenshot)</label>
                {item.image ? (
                  <div>
                    <img src={item.image} alt={item.title} style={{ width: "100%", maxHeight: "200px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e2e8f0" }} />
                    <button onClick={() => removeImage(item.id)} style={{ marginTop: "8px", background: "#ef4444", color: "white", border: "none", padding: "6px 12px", borderRadius: "6px", cursor: "pointer", fontSize: "0.85rem" }}>Gorseli Kaldir</button>
                  </div>
                ) : (
                  <label style={{ display: "block", padding: "24px", border: "2px dashed #e2e8f0", borderRadius: "8px", textAlign: "center", cursor: "pointer", color: "#94a3b8" }}>
                    📸 Gorsel yuklemek icin tiklayin (PNG/JPG)
                    <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { if (e.target.files && e.target.files[0]) handleImageUpload(item.id, e.target.files[0]); }} />
                  </label>
                )}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
                <div>
                  <label style={labelStyle}>Proje Adi</label>
                  <input value={item.title} onChange={(e) => updatePortfolio(item.id, "title", e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Domain</label>
                  <input value={item.domain} onChange={(e) => updatePortfolio(item.id, "domain", e.target.value)} style={inputStyle} />
                </div>
              </div>
              <label style={labelStyle}>Aciklama</label>
              <textarea value={item.description} onChange={(e) => updatePortfolio(item.id, "description", e.target.value)} rows={2} style={inputStyle} />
            </div>
          ))}
        </div>
      )}

      {/* VIDEOS */}
      {activeTab === "videos" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
            <h2>Canli Altyazi Videolari</h2>
            <button className="btn-primary" onClick={addVideo}>+ Yeni Video</button>
          </div>
          <p style={{ color: "#64748b", marginBottom: "20px", fontSize: "0.9rem" }}>
            Cloudinary'ye yuklediginiz videonun URL'sini buraya yapistirin. Ornek: https://res.cloudinary.com/xxx/video/upload/xxx.mp4
          </p>
          {(data.videos || []).map((item) => (
            <div key={item.id} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px", marginBottom: "16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <h3>Video #{item.id}</h3>
                <button onClick={() => removeVideo(item.id)} style={{ background: "#ef4444", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer" }}>Sil</button>
              </div>
              <div style={{ marginBottom: "12px" }}>
                <label style={labelStyle}>Video Adi</label>
                <input value={item.title} onChange={(e) => updateVideo(item.id, "title", e.target.value)} style={inputStyle} />
              </div>
              <div style={{ marginBottom: "12px" }}>
                <label style={labelStyle}>Aciklama</label>
                <input value={item.description} onChange={(e) => updateVideo(item.id, "description", e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Cloudinary Video URL</label>
                <input value={item.url} onChange={(e) => updateVideo(item.id, "url", e.target.value)} placeholder="https://res.cloudinary.com/xxx/video/upload/xxx.mp4" style={inputStyle} />
              </div>
              {item.url && (
                <div style={{ marginTop: "12px" }}>
                  <label style={labelStyle}>Onizleme</label>
                  <video src={item.url} controls style={{ width: "100%", maxHeight: "300px", borderRadius: "8px", background: "#000" }} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ABOUT */}
      {activeTab === "about" && (
        <div>
          <h2 style={{ marginBottom: "24px" }}>Hakkimda Bolumu</h2>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Baslik</label>
            <input value={data.about.title} onChange={(e) => updateAbout("title", e.target.value)} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Aciklama 1</label>
            <textarea value={data.about.description1} onChange={(e) => updateAbout("description1", e.target.value)} rows={3} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Aciklama 2 (Dunya Sampiyonlugu)</label>
            <textarea value={data.about.description2} onChange={(e) => updateAbout("description2", e.target.value)} rows={3} style={inputStyle} />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={labelStyle}>Aciklama 3</label>
            <textarea value={data.about.description3} onChange={(e) => updateAbout("description3", e.target.value)} rows={3} style={inputStyle} />
          </div>
          <h3 style={{ marginTop: "20px", marginBottom: "12px" }}>Istatistikler</h3>
          {[
            ["stat1Number", "Sayi 1", "stat1Label", "Etiket 1"],
            ["stat2Number", "Sayi 2", "stat2Label", "Etiket 2"],
            ["stat3Number", "Sayi 3", "stat3Label", "Etiket 3"],
            ["stat4Number", "Sayi 4", "stat4Label", "Etiket 4"],
          ].map(([numField, numLabel, lblField, lblLabel]) => (
            <div key={numField} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
              <div>
                <label style={labelStyle}>{numLabel}</label>
                <input value={(data.about as any)[numField]} onChange={(e) => updateAbout(numField, e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>{lblLabel}</label>
                <input value={(data.about as any)[lblField]} onChange={(e) => updateAbout(lblField, e.target.value)} style={inputStyle} />
              </div>
            </div>
          ))}
          <h3 style={{ marginTop: "20px", marginBottom: "12px" }}>Uzmanlik Alanlari</h3>
          {data.about.skills.map((skill, i) => (
            <div key={i} style={{ border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px", marginBottom: "12px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <span style={{ fontWeight: 600 }}>Alan #{i + 1}</span>
                <button onClick={() => removeSkill(i)} style={{ background: "#ef4444", color: "white", border: "none", padding: "4px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "0.8rem" }}>Sil</button>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "60px 1fr", gap: "12px" }}>
                <div>
                  <label style={labelStyle}>Icon</label>
                  <input value={skill.icon} onChange={(e) => updateSkill(i, "icon", e.target.value)} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Baslik</label>
                  <input value={skill.title} onChange={(e) => updateSkill(i, "title", e.target.value)} style={inputStyle} />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Aciklama</label>
                <input value={skill.desc} onChange={(e) => updateSkill(i, "desc", e.target.value)} style={inputStyle} />
              </div>
            </div>
          ))}
          <button onClick={addSkill} style={{ background: "#10b981", color: "white", border: "none", padding: "10px 20px", borderRadius: "8px", cursor: "pointer", fontWeight: 600 }}>+ Yeni Alan Ekle</button>
        </div>
      )}

      {/* CONTACT */}
      {activeTab === "contact" && (
        <div>
          <h2 style={{ marginBottom: "24px" }}>Iletisim Bilgileri</h2>
          {[
            ["phone", "Telefon"],
            ["email", "E-posta"],
            ["location", "Konum"],
            ["workingHours", "Calisma Saatleri"],
          ].map(([field, label]) => (
            <div key={field} style={{ marginBottom: "12px" }}>
              <label style={labelStyle}>{label}</label>
              <input value={(data.contact as any)[field]} onChange={(e) => updateContact(field, e.target.value)} style={inputStyle} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Admin;
